import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {EnquiryResponse, APIResponse, VehicleResponse, NearByDriverResponse} from '../models/common';

@Injectable({
  providedIn: 'root'
})
export class PostEnquiryService {
  constructor(private http: HttpClient) {
  }

  submitTransportPublic(param) {
    return this.http.post<EnquiryResponse>('enquiry/transport/public', param)
      .pipe(map(data => new EnquiryResponse(data)));
  }

  submitTransportGoods(param) {
    return this.http.post<EnquiryResponse>('enquiry/transport/goods', param)
      .pipe(map(data => new EnquiryResponse(data)));
  }

  submitRentalHeavy(param) {
    return this.http.post<EnquiryResponse>('enquiry/rental/heavy', param)
      .pipe(map(data => new EnquiryResponse(data)));
  }

  submitRentalGoods(param) {
    return this.http.post<EnquiryResponse>('enquiry/rental/goods', param)
      .pipe(map(data => new EnquiryResponse(data)));
  }

  submitRentalOthers(param) {
    return this.http.post<EnquiryResponse>('enquiry/rental/others', param)
      .pipe(map(data => new EnquiryResponse(data)));
  }

  submitDelivery(param) {
    return this.http.post<EnquiryResponse>('enquiry/delivery', param)
      .pipe(map(data => new EnquiryResponse(data)));
  }

  getLocationId(param) {
    return this.http.post('location', param)
      .pipe(map(data => data));
  }

  fetchVehicles(param = '') {
    return this.http.get<VehicleResponse>('vehicle', {
      params: {
        search: param
      }
    }).pipe(map(data => new VehicleResponse(data)));
  }

  fetchTypeVehicles(param = '', type, brand = null) {
    const opt = brand == null ? {type_id: type, search: param} : {type_id: type, brand_id: brand, search: param};
    return this.http.get('vehicle', {params: opt}).pipe(map(data => new VehicleResponse(data)));
  }

  fetchCommodity(param = '',category='') {
    return this.http.get<VehicleResponse>('commodity', {
      params: {
        search: param,
        category: category
      }
    })
      .pipe(map(data => new VehicleResponse(data)));
  }

  getLocaleDrivers({lat = '', lng = ''}, categoryId) {
    const body = {pickupLat: lat, pickupLong: lng, range_in_meter: 10000, categoryId};
    return this.http.post('drivers-nearby', body)
      .pipe(map(data => data));
  }

  getPrice() {
    return this.http.get('delivery-charge').pipe(map(data => data));
  }
}
